/**
 * What actually reviewed an audit's screenshots, for display.
 *
 * Exists as its own module because the naive version of this was a bug: the detail screen
 * read `vision_model` — the REQUEST, which is null whenever the operator leaves the picker
 * on Auto — and so showed a bare "on" for essentially every run. Nobody could tell which
 * model had looked at their screens, or which key had been billed.
 *
 * The row carries both: `vision_model` / `vision_connection_id` are what was asked for
 * (null = auto), and `resolved_vision_model` / `resolved_vision_connection_id` are what the
 * worker actually used. Read the outcome; keep the request so "auto" stays visible.
 */
export function visionSummaryFields(audit) {
  if (!audit || !audit.vision_enabled) {
    return { state: 'off', model: null, connectionId: null };
  }
  if (!audit.resolved_vision_model) {
    const running = audit.status === 'pending' || audit.status === 'running';
    // "not-run" is a real outcome, not an error: the visual review is skipped when no
    // AI model connection exists, and the measured checks still ran.
    return { state: running ? 'pending' : 'not-run', model: null, connectionId: null };
  }
  return {
    state: 'reviewed',
    model: audit.resolved_vision_model,
    connectionId: audit.resolved_vision_connection_id ?? null,
  };
}

const LABELS = { off: 'off', pending: 'pending', 'not-run': 'not run' };

/** The single value the summary tile shows. */
export function visionSummaryLabel(audit) {
  const f = visionSummaryFields(audit);
  return f.state === 'reviewed' ? f.model : LABELS[f.state];
}
